// TODO(gemma): Convert all to tsx?...
// Also, what if we moved these into the component folders so we wouldnt have to import crazy relative paths..?
// but again, replacing some of the relative imports would help.
import moment from 'moment';

// The inputs all have the correct number of characters.
export function dateInputFilled({ month, day, year }): boolean {
  if (
    month &&
    month.length === 2 &&
    day &&
    day.length === 2 &&
    year &&
    year.length === 4
  ) {
    return true;
  }
  return false;
}

// Given a local month/day/year, determine what the full date/time would be in UTC,
// so we can effectively return the expected "local date".
export function getLocalDateFromOffset({ year, month, day, tzOffsetInHours }) {
  // We will generate a date using the previous day if the offset is negative.
  const previousDay = tzOffsetInHours < 0;
  // Determine what the day's "start hour" will be in UTC (we will subtract from hour 24 if prev day).
  const startTime = previousDay ? 24 : 0; //
  const hourUTC = startTime + tzOffsetInHours;
  // Use the hour difference when generating the date, so it will be in "local time".
  let hourUTCString = `${hourUTC}`;
  if (hourUTCString.length === 1) {
    hourUTCString = `0${hourUTCString}`;
  }
  if (hourUTCString.length !== 2) {
    console.error('invalid time zone offset');
    // Fallback to 00 default.
    hourUTCString = '00';
  }
  // Create the adjusted birthdate.
  const localDateString = `${year}-${month}-${day}T${hourUTCString}:00:00Z`;
  const localDate = new Date(localDateString);
  if (previousDay) {
    // This automatically handles switching month and year if needed.
    localDate.setDate(localDate.getDate() - 1);
  }
  return localDate;
}

// This is actually a valid date.
export function isValidDate({ year, month, day }): boolean {
  return moment(`${year} ${month} ${day}`, 'YYYY MM DD', true).isValid();
}

export function isLegalAgeForAlcohol({ year, month, day }): boolean {
  const today = new Date();
  // Calculate the local timezone offset from UTC. Note: UTC-8 will return 8, UTC+3 will return -3.
  const currentTimeZoneOffsetInHours = today.getTimezoneOffset() / 60;
  // The inputted values assume local time (rather than UTC), so calculate what this would be.
  const birthDate = getLocalDateFromOffset({
    year,
    month,
    day,
    tzOffsetInHours: currentTimeZoneOffsetInHours,
  });

  let age = today.getFullYear() - birthDate.getFullYear();
  // const month = today.getMonth() - birthDate.getMonth();
  const currentMonth = today.getMonth() - birthDate.getMonth();
  if (
    currentMonth < 0 ||
    (currentMonth === 0 && today.getDate() < birthDate.getDate())
  ) {
    age -= 1;
  }
  return age >= 21;
}

// TODO(gemma): Some of these dont seem like they are validators... more straight utils on date.
export function sanitizeMonth(month: ?string): string {
  if (!month) return '';
  return month.length === 1 ? `0${month}` : month;
}

export function sanitizeDay(day: ?string): string {
  if (!day) return '';
  return day.length === 1 ? `0${day}` : day;
}

export function sanitizeYear(year: ?string): string {
  if (!year) return '';
  return year.length === 2 ? `19${year}` : year;
}

export function getSanitizedProperty(
  propertyName: string,
  propertyVal: string,
) {
  const propDictionary = {
    month: () => sanitizeMonth(propertyVal),
    day: () => sanitizeDay(propertyVal),
    year: () => sanitizeYear(propertyVal),
  };
  return propDictionary[propertyName]();
}

export function generateDate(month: string, day: string, year: string): string {
  const newMonth = sanitizeMonth(month);
  const newDay = sanitizeDay(day);
  const newYear = sanitizeYear(year);
  return `${newMonth}/${newDay}/${newYear}`;
}

export function dateStringToState(dateString: string | null) {
  if (!dateString) {
    return {
      year: '',
      month: '',
      day: '',
    };
  }
  return {
    year: dateString.substring(6, 10),
    month: dateString.substring(0, 2),
    day: dateString.substring(3, 5),
  };
}
